// removed by extract-text-webpack-plugin
module.exports = {"DemoBrowser":"demoBrowser__DemoBrowser__fcYSU","BrowserMenu":"demoBrowser__BrowserMenu__16zb2","Circles":"demoBrowser__Circles__lEqQu","Circle":"demoBrowser__Circle__1Vtdy","Red":"demoBrowser__Red__3AxCX","Yellow":"demoBrowser__Yellow__ucl7V","Green":"demoBrowser__Green__wBQO6"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/DemoBrowser/demoBrowser.css
// module id = 926
// module chunks = 2